
(function(){
  if (window.__lafsContrast) return;
  window.__lafsContrast = 1;

  var MIN = 3.4;      /* repair anything below this */
  var TARGET = 4.8;   /* and take it to here */
  var SKIP_TAG = /^(SCRIPT|STYLE|NOSCRIPT|SVG|PATH|CANVAS|IFRAME|INPUT|TEXTAREA|SELECT|OPTION|VIDEO|IMG|BR|HR)$/;

  function parse(c){
    var m = (c || '').match(/[\d.]+/g);
    if (!m || m.length < 3) return null;
    return { r:+m[0], g:+m[1], b:+m[2], a: m.length > 3 ? +m[3] : 1 };
  }
  function lum(o){
    function f(x){ x /= 255; return x <= 0.03928 ? x/12.92 : Math.pow((x+0.055)/1.055, 2.4); }
    return 0.2126*f(o.r) + 0.7152*f(o.g) + 0.0722*f(o.b);
  }
  function over(f, b){
    var a = f.a;
    return { r: f.r*a + b.r*(1-a), g: f.g*a + b.g*(1-a), b: f.b*a + b.b*(1-a), a: 1 };
  }
  function ratio(a, b){
    var x = lum(a), y = lum(b);
    return (Math.max(x,y) + 0.05) / (Math.min(x,y) + 0.05);
  }

  /* Text sitting on a photograph: the picture is the background and the scrim
     over it is doing the work, so the color must be left alone. Detected
     geometrically — an <img> nearby that covers this element's box — because
     the image is usually a sibling element rather than a CSS background. */
  function overPhoto(el){
    var r = el.getBoundingClientRect(), n = el, d = 0;
    while (n && n.nodeType === 1 && d < 5) {
      var imgs = n.getElementsByTagName ? n.getElementsByTagName('img') : [];
      for (var i = 0; i < imgs.length; i++) {
        var ir = imgs[i].getBoundingClientRect();
        if (ir.width > 24 && ir.height > 24 &&
            ir.left <= r.left + 2 && ir.top <= r.top + 2 &&
            ir.right >= r.right - 2 && ir.bottom >= r.bottom - 2) return true;
      }
      n = n.parentNode; d++;
    }
    return false;
  }

  /* The real painted background: composite every translucent layer upward until
     an opaque one is reached. A gradient is a background like any other and its
     stops are averaged — an earlier version bailed on every background-image,
     which silently skipped the promo band and every gradient-backed section on
     the site. Only a real image (url(...)) is refused, and that case is already
     covered by overPhoto above. */
  function ground(el){
    var layers = [], n = el;
    while (n && n !== document.documentElement) {
      var cs = window.getComputedStyle(n);
      var bi = cs.backgroundImage;
      if (bi && bi !== 'none') {
        if (bi.indexOf('url(') !== -1) return null;
        var stops = bi.match(/rgba?\([^)]*\)/g) || [];
        if (stops.length) {
          var avg = { r:0, g:0, b:0, a:1 }, used = 0;
          for (var s = 0; s < stops.length; s++) {
            var p = parse(stops[s]);
            if (!p || p.a === 0) continue;
            avg.r += p.r; avg.g += p.g; avg.b += p.b; used++;
          }
          if (used) {
            avg.r /= used; avg.g /= used; avg.b /= used;
            layers.push(avg);
            break;
          }
        }
      }
      var c = parse(cs.backgroundColor);
      if (c && c.a > 0) { layers.push(c); if (c.a >= 0.99) break; }
      n = n.parentNode;
      if (!n || n.nodeType !== 1) break;
    }
    if (!layers.length) return { r:255, g:255, b:255, a:1 };
    var base = layers[layers.length - 1];
    if (base.a < 0.99) base = over(base, { r:255, g:255, b:255, a:1 });
    for (var i = layers.length - 2; i >= 0; i--) base = over(layers[i], base);
    return base;
  }

  function toHsl(o){
    var r = o.r/255, g = o.g/255, b = o.b/255;
    var mx = Math.max(r,g,b), mn = Math.min(r,g,b), d = mx - mn;
    var h = 0, s = 0, l = (mx + mn) / 2;
    if (d) {
      s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn);
      if (mx === r) h = ((g - b) / d + (g < b ? 6 : 0));
      else if (mx === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }
    return { h:h, s:s, l:l };
  }
  function toRgb(hsl){
    var h = hsl.h, s = hsl.s, l = hsl.l;
    function hue(p, q, t){
      if (t < 0) t += 1; if (t > 1) t -= 1;
      if (t < 1/6) return p + (q - p) * 6 * t;
      if (t < 1/2) return q;
      if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
      return p;
    }
    if (!s) { var v = Math.round(l * 255); return { r:v, g:v, b:v, a:1 }; }
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q;
    return { r: Math.round(hue(p,q,h+1/3)*255), g: Math.round(hue(p,q,h)*255), b: Math.round(hue(p,q,h-1/3)*255), a:1 };
  }

  /* Keep the hue, move the lightness until the text clears TARGET. Near-neutral
     colors have no hue worth keeping, so they go straight to ink or paper. */
  function repair(fg, bg){
    var hsl = toHsl(fg);
    var goDark = lum(bg) > 0.35;
    if (hsl.s < 0.12) return goDark ? { r:18, g:18, b:26, a:1 } : { r:255, g:255, b:255, a:1 };
    var lo = goDark ? 0 : hsl.l, hi = goDark ? hsl.l : 1, best = null;
    for (var i = 0; i < 18; i++) {
      var mid = (lo + hi) / 2;
      var cand = toRgb({ h:hsl.h, s:hsl.s, l:mid });
      if (ratio(cand, bg) >= TARGET) { best = cand; if (goDark) lo = mid; else hi = mid; }
      else { if (goDark) hi = mid; else lo = mid; }
    }
    if (best) return best;
    return goDark ? { r:18, g:18, b:26, a:1 } : { r:255, g:255, b:255, a:1 };
  }

  function hasOwnText(el){
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim().length > 1) return true;
    }
    return false;
  }

  function pass(){
    var els = document.body ? document.body.getElementsByTagName('*') : [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.nodeType !== 1 || SKIP_TAG.test(el.tagName)) continue;
      if (el.getAttribute('data-lafs-contrast')) continue;
      if (el.closest && el.closest('svg')) continue;
      if (!hasOwnText(el)) continue;

      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4) continue;

      var cs = window.getComputedStyle(el);
      /* visibility:hidden is a closed drawer or menu panel and can be left; a
         zero opacity is almost always a scroll-reveal that has not fired yet.
         An earlier version skipped those too, which meant everything below the
         fold was never examined — the passes all ran while most of the page was
         still at opacity 0, so only the first screen was ever corrected and the
         closing call-to-action was never reached. Opacity does not affect the
         colors, so it is measured and repaired regardless. */
      if (cs.visibility === 'hidden' || cs.display === 'none') continue;
      /* A gradient clipped to the glyphs paints the text itself; leave it be. */
      if (/text/.test(cs.webkitBackgroundClip || '') || /text/.test(cs.backgroundClip || '')) continue;

      if (overPhoto(el)) continue;
      var bg = ground(el);
      if (!bg) continue;

      var raw = (cs.webkitTextFillColor && cs.webkitTextFillColor !== 'rgba(0, 0, 0, 0)')
                ? cs.webkitTextFillColor : cs.color;
      var fg = parse(raw);
      if (!fg || fg.a === 0) continue;
      var solid = fg.a < 1 ? over(fg, bg) : fg;

      if (ratio(solid, bg) >= MIN) continue;

      var out = repair(solid, bg);
      el.style.setProperty('color', 'rgb(' + out.r + ',' + out.g + ',' + out.b + ')', 'important');
      if (cs.webkitTextFillColor && cs.webkitTextFillColor !== 'rgba(0, 0, 0, 0)') {
        el.style.setProperty('-webkit-text-fill-color', 'rgb(' + out.r + ',' + out.g + ',' + out.b + ')', 'important');
      }
      el.setAttribute('data-lafs-contrast', '1');
    }
  }

  function boot(){
    try { pass(); } catch (e) {}
    /* Lazy sections and app embeds arrive after first paint, so the sweep is
       repeated. A scroll-triggered pass covers anything mounted later still —
       throttled, and cheap after the first run because every element it has
       already judged carries the marker and is skipped. */
    setTimeout(function(){ try { pass(); } catch (e) {} }, 700);
    setTimeout(function(){ try { pass(); } catch (e) {} }, 2200);
    setTimeout(function(){ try { pass(); } catch (e) {} }, 5000);

    var queued = false;
    window.addEventListener('scroll', function(){
      if (queued) return;
      queued = true;
      setTimeout(function(){ queued = false; try { pass(); } catch (e) {} }, 400);
    }, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
